import Vue from 'vue'
import Vuex from 'vuex'
import { toggleFav } from '@/api/site'

Vue.use(Vuex)

const FAV_KEY = 'tool_favorites'

export default new Vuex.Store({
  state: {
    favorites: JSON.parse(localStorage.getItem(FAV_KEY) || '[]')
  },
  mutations: {
    ADD_FAV(state, tool) {
      if (!state.favorites.find(f => f.id === tool.id)) {
        state.favorites.push(tool)
        localStorage.setItem(FAV_KEY, JSON.stringify(state.favorites))
      }
    },
    REMOVE_FAV(state, toolId) {
      state.favorites = state.favorites.filter(f => f.id !== toolId)
      localStorage.setItem(FAV_KEY, JSON.stringify(state.favorites))
    }
  },
  actions: {
    toggleFavAction({ commit, state }, tool) {
      const isFav = state.favorites.find(f => f.id === tool.id)
      if (isFav) {
        commit('REMOVE_FAV', tool.id)
      } else {
        commit('ADD_FAV', tool)
      }
      toggleFav(tool.id, !isFav).catch(() => {})
    }
  },
  getters: {
    isFav: state => toolId => state.favorites.some(f => f.id === toolId),
    favorites: state => state.favorites
  }
})
